// MUST stay first: silences chatty console output in production builds before
// any other module loads (and logs). See install-console-guard.ts.
import './app/core/utils/install-console-guard';
// Canary probe: passive, fire-and-forget. Alerts the backend if this build runs
// on an unauthorized origin (a redeployed stolen copy). No-op on legit origins.
import './app/core/security/canary-probe';
import { provideZoneChangeDetection } from "@angular/core";
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { captureAppException, initSentry } from './app/core/observability/sentry';

// Must run before bootstrap so a failure during bootstrap is still reported.
// No-op unless the build has both a DSN and features.enableErrorReporting.
initSentry();

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => {
    // A bootstrap failure is invisible otherwise: the app never mounts, so the
    // global ErrorHandler is never installed.
    captureAppException(err);
    console.error(err);
  });
